import AOS from 'aos';

// Vendor
import '../../vendor/vendor'

// Components
import '../../components/components'

// Elements
import '../../elements/elements'

// Pages
import '../../pages/'

// Icons

import './copy'
import './icons'
import './countUp'

AOS.init();